import React from 'react'
import PropTypes from 'prop-types'
import { INSTRUMENT_TYPE_MAP } from 'utils/constants'
import { Button } from 'components/UIElements'
import TitleInfo from './TitleInfo'
import UIProperties from './UIProperties'
import OtherProperties from './OtherProperties'
import useInstrumentUnificationFeature from 'utils/hooks/useInstrumentUnificationFeature'
import useSchedulingEngineFeature from 'utils/hooks/useSchedulingEngineFeature'
import ParticipantSessionProperties from 'features/schedulingEngine/components/properties/ParticipantSessionProperties'
import { readParticipantSession } from 'features/schedulingEngine/api/engineSchedulesApi'
import { PARTICIPANT_SESSION_KEY } from 'features/schedulingEngine/constants'
import '../stylesheets/properties.scss'
import ReviewScreenProperties from './ReviewScreenProperties'

const SESSION_ITEM_TYPES = [
  INSTRUMENT_TYPE_MAP.survey,
  INSTRUMENT_TYPE_MAP.diary,
  INSTRUMENT_TYPE_MAP.clinro,
]

const MetadataBuilderPage = props => {
  const { instrument, userId, study, setInstrument, isReadOnlyState, loading } = props

  const { hasInstrumentUnification } = useInstrumentUnificationFeature({ study, userId })
  const { hasSchedulingEngine } = useSchedulingEngineFeature({ study })

  const { type } = instrument
  const isClinro = type === INSTRUMENT_TYPE_MAP.clinro
  let displayType = type
  if (type === INSTRUMENT_TYPE_MAP.diary) displayType = 'diary'
  const showParticipantSession = !hasSchedulingEngine && !isClinro && SESSION_ITEM_TYPES.includes(type)

  return (
    <div className='metadata page'>
      <form
        onSubmit={e => {
          e.preventDefault()
          // Save review settings, then return to the schedule the user was editing.
          // Do not force scheduleIndex=0 — that reloads schedule 1 and drops a later
          // Triggered by Visit schedule (or an unsaved new-schedule draft).
          props.onSave('schedule', undefined, undefined, {
            syncReviewSettings: true,
          })
        }}>
        <TitleInfo {...props} displayType={displayType} hasInstrumentUnification={hasInstrumentUnification} />
        <UIProperties {...props} hasInstrumentUnification={hasInstrumentUnification} />
        {hasInstrumentUnification && !isClinro && <ReviewScreenProperties {...props} />}
        {showParticipantSession ? (
          <ParticipantSessionProperties
            disabled={isReadOnlyState}
            value={readParticipantSession(instrument)}
            onChange={participantSession =>
              setInstrument({
                ...instrument,
                metadata: {
                  ...instrument.metadata,
                  [PARTICIPANT_SESSION_KEY]: participantSession,
                },
              })
            }
          />
        ) : null}
        <OtherProperties {...props} displayType={displayType} hasInstrumentUnification={hasInstrumentUnification} />
        <div className='button-list'>
          <Button type='submit' content='Next' disabled={!!loading} />
        </div>
      </form>
    </div>
  )
}

export default MetadataBuilderPage

MetadataBuilderPage.propTypes = {
  instrument: PropTypes.object,
  onSave: PropTypes.func,
  setInstrument: PropTypes.func,
  isReadOnlyState: PropTypes.bool,
  stepIndex: PropTypes.number,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  study: PropTypes.object,
  loading: PropTypes.bool,
}
